import React, { ReactNode, useState } from "react"

export enum EActivationBreakpoint {
    sm = "sm",
    md = "md",
    lg = "lg",
    xl = "xl",
    _2xl = "2xl",
    alwaysActive = "alwaysActive",
}

export interface IFilterDropdown {
    classNames?: string;
    buttonClassName?: string;
    fieldsBoxClassName?: string;
    title: string;
    deactivationBreakpoint?: EActivationBreakpoint;
    children: ReactNode;
}

export const FilterDropdown: React.FC<IFilterDropdown> = ({
    classNames = "",
    buttonClassName = "",
    fieldsBoxClassName = "",
    title,
    deactivationBreakpoint = EActivationBreakpoint.alwaysActive,
    children,
}) => {

    let activeClass = "absolute"
    let hiddenClass = "hidden"
    let buttonLayoutClass = ""
    switch (deactivationBreakpoint) {
        case EActivationBreakpoint.sm:
            activeClass = "absolute sm:relative";
            hiddenClass = "hidden sm:block";
            buttonLayoutClass = "inline-block sm:hidden";
            break;
        case EActivationBreakpoint.md:
            activeClass = "absolute md:relative";
            hiddenClass = "hidden md:block";
            buttonLayoutClass = "inline-block md:hidden";
            break;
        case EActivationBreakpoint.lg:
            activeClass = "absolute lg:relative";
            hiddenClass = "hidden lg:block";
            buttonLayoutClass = "inline-block lg:hidden";
            break;
        case EActivationBreakpoint.xl:
            activeClass = "absolute xl:relative";
            hiddenClass = "hidden xl:block";
            buttonLayoutClass = "inline-block xl:hidden";
            break;
        case EActivationBreakpoint._2xl:
            activeClass = "abslute 2xl:relative";
            hiddenClass = "hidden 2xl:block";
            buttonLayoutClass = "inline-block 2xl:hidden";
            break;
        default:
            break;
    }

    const [filterOpen, setFilterOpen] = useState(false)

    const arrowsClasses = "after:content-[''] after:border-body-text after:h-2 after:w-2 after:inline-block after:border-r-2 after:border-b-2"

    return (
        <div onBlur={(e) => !e.currentTarget.contains(e.relatedTarget) && setFilterOpen(false)} tabIndex={filterOpen ? 0 : -1} className={`relative ${classNames}`}>
            <button type="button" className={`${arrowsClasses} ${!filterOpen ? "after:rotate-45 after:-mt-1" : "after:-rotate-[135deg] after:mt-1"} flex items-center gap-2 bg-transparent text-body-text normal-case ${buttonLayoutClass} ${buttonClassName}`} onClick={() => setFilterOpen(!filterOpen)}>{title}</button>
            <div className={`${!filterOpen ? `${hiddenClass}` : ""} ${activeClass} px-5 py-4 w-max z-10 shadow-lg ${fieldsBoxClassName}`}>
                {children}
            </div>
        </div>
    )
}

export default FilterDropdown